import { z } from 'zod';


// #/components/schemas/settingsTraceParent
export const SettingsTraceParentZod = z.string();
export type SettingsTraceParentType = z.TypeOf<typeof SettingsTraceParentZod>;


// #/components/schemas/settingsTraceState
export const SettingsTraceStateZod = z.string();
export type SettingsTraceStateType = z.TypeOf<typeof SettingsTraceStateZod>;


// #/components/schemas/settingsDeployment
export const SettingsDeploymentZod = z.object({
    name: z.string(),
    namespace: z.string(),
});
export type SettingsDeploymentType = z.TypeOf<typeof SettingsDeploymentZod>;


// #/components/schemas/settingsSettings
export const SettingsSettingsZod = z.object({
    id: z.string(),
    deployment: SettingsDeploymentZod.optional(),
    schema: z.unknown(),
    value: z.unknown(),
    customValuePaths: z.array(z.string()),
});
export type SettingsSettingsType = z.TypeOf<typeof SettingsSettingsZod>;

